var React = require('react');

function IconEllipsisSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64 511.9C64 572.7 113.3 622 174.1 622s110.1-49.3 110.1-110.1-49.3-110.1-110.1-110.1S64 451.1 64 511.9zm673.5.8c0 60.8 49.3 110.1 110.1 110.1s110.1-49.3 110.1-110.1-49.3-110.1-110.1-110.1-110.1 49.3-110.1 110.1zm-335.8-.6c0 60.8 49.3 110.1 110.1 110.1s110.1-49.3 110.1-110.1S572.5 402 511.7 402s-110 49.3-110 110.1z"}));
}

IconEllipsisSolid.displayName = "IconEllipsisSolid";

IconEllipsisSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconEllipsisSolid;

IconEllipsisSolid.default = IconEllipsisSolid;
